import { DiscriminatorStruct } from "../../structs/risk-classification/discriminator.struct";

export class DiscriminatorRequest {
    public discriminator: DiscriminatorStruct;
}